<div class="row page-header">
  <app-headertext text="PDF-eksporter"></app-headertext>
  <div class="fill-space"></div>
  <button mat-button type="button" class="header-row-button" [routerLink]="['/p', projectId, 'sl']">
    <mat-icon>list_alt</mat-icon> Til sjekklistene
  </button>
</div>

<main class="exports-page" aria-label="PDF-eksporter" [attr.aria-busy]="loading">
  <mat-progress-bar *ngIf="loading" mode="indeterminate" aria-label="Laster PDF-eksporter"></mat-progress-bar>

  <mat-card *ngIf="user && !user.superAdmin" class="empty-state">
    <mat-icon>lock</mat-icon>
    <h2>Ingen tilgang</h2>
    <p>PDF-eksporter er tilgjengelig for superadministratorer.</p>
  </mat-card>

  <mat-card *ngIf="error" class="error-state" role="alert">
    <mat-icon color="warn">error_outline</mat-icon>
    <p>{{ error }}</p>
    <button mat-button (click)="loadExports()" [disabled]="loading || requestPending">Prøv igjen</button>
  </mat-card>

  <ng-container *ngIf="user?.superAdmin">
    <mat-card *ngIf="!loading && !error && !jobs.length" class="empty-state">
      <mat-icon color="primary">folder_open</mat-icon>
      <h2>Ingen PDF-eksporter ennå</h2>
      <p>Start en eksport fra sjekklistene. Her finner du fremdrift, ferdige ZIP-filer og eventuelle feil.</p>
      <button mat-raised-button type="button" color="primary" [routerLink]="['/p', projectId, 'sl']">Gå til sjekklistene</button>
    </mat-card>

    <mat-card *ngIf="jobs.length" class="history-card">
      <mat-form-field appearance="fill" class="export-selector">
        <mat-label>Velg eksport</mat-label>
        <mat-select [value]="report?.id" (selectionChange)="openExport($event.value)" [disabled]="loading || requestPending">
          <mat-option *ngFor="let job of jobs" [value]="job.id">
            {{ job.createdAt | date:'dd.MM.yyyy HH:mm' }} · {{ job.total }} PDF-er · {{ statusLabel(job.status) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-button *ngIf="nextJobId" (click)="loadOlderExports()" [disabled]="loadingHistory || requestPending">
        {{ loadingHistory ? 'Laster…' : 'Vis eldre eksporter' }}
      </button>
    </mat-card>

    <mat-card *ngIf="report as job" class="export-card">
      <div class="export-heading">
        <div>
          <h2>{{ statusLabel(job.status) }}</h2>
          <p class="muted">Opprettet {{ job.createdAt | date:'dd.MM.yyyy HH:mm' }}</p>
        </div>
        <mat-icon [color]="job.status === 'COMPLETED' ? 'primary' : 'accent'" aria-hidden="true">
          {{ job.status === 'COMPLETED' ? 'check_circle_outline' : job.failed || job.status === 'FAILED' ? 'error_outline' : 'schedule' }}
        </mat-icon>
      </div>

      <dl class="export-counts">
        <div><dt>PDF-er i utvalget</dt><dd>{{ job.total }}</dd></div>
        <div><dt>{{ job.status === 'COMPLETED' || job.status === 'ARCHIVING' ? 'I ZIP-filen' : 'Kontrollert' }}</dt><dd>{{ job.status === 'COMPLETED' || job.status === 'ARCHIVING' ? job.archived : job.checked }}</dd></div>
        <div><dt>Filer med feil</dt><dd>{{ job.failed }}</dd></div>
      </dl>

      <div *ngIf="working" class="progress" role="status" aria-live="polite">
        <mat-progress-bar [mode]="job.status === 'CHECKING' || job.status === 'ARCHIVING' ? 'determinate' : 'indeterminate'"
                          [value]="progress" [attr.aria-label]="statusLabel(job.status)"></mat-progress-bar>
        <p>Du kan forlate siden. Eksporten fortsetter, og du kan hente filen her når den er klar.</p>
      </div>
      <p *ngIf="job.status === 'AWAITING_DECISION'" role="status">Noen PDF-er mangler eller kunne ikke behandles. Velg hvordan du vil fortsette nedenfor.</p>
      <p *ngIf="job.status === 'FAILED'" role="status">Eksporten kunne ikke fullføres. Du kan prøve igjen med det samme utvalget.</p>
      <p *ngIf="job.error" class="job-error" role="alert">{{ job.error }}</p>

      <div class="actions">
        <button mat-raised-button color="primary" *ngIf="job.status === 'COMPLETED'" (click)="download()" [disabled]="requestPending">
          <mat-icon>download</mat-icon> Last ned ZIP{{ job.failed ? ' (delvis)' : '' }} · {{ job.bytes | fileSize:1 }}
        </button>
        <button mat-raised-button color="primary" *ngIf="job.status === 'FAILED'" (click)="retry()" [disabled]="requestPending">Prøv eksporten igjen</button>
        <button mat-stroked-button *ngIf="job.hasReport" (click)="download(true)" [disabled]="requestPending">
          <mat-icon>description</mat-icon> Last ned feilrapport
        </button>
        <button mat-stroked-button *ngIf="job.status === 'COMPLETED'" (click)="markDelivered()" [disabled]="!canMarkDelivered">
          <mat-icon>done_all</mat-icon>
          {{ job.delivery?.retryable ? 'Prøv merking på nytt' : job.delivery?.completedAt ? 'Merking fullført' : job.delivery ? 'Fortsett merking som sendt' : 'Merk alle som sendt til kunde' }}
        </button>
      </div>
      <mat-progress-bar *ngIf="markingDelivery" mode="indeterminate" aria-label="Markerer som sendt til kunde"></mat-progress-bar>
      <div *ngIf="job.delivery as delivery" role="status" aria-live="polite">
        <p *ngIf="!delivery.completedAt">{{ markingDelivery ? 'Markerer' : 'Merking satt på pause' }}: {{ delivery.cursor }} av {{ delivery.total }} sjekklister behandlet.</p>
        <p *ngIf="delivery.completedAt">Merking fullført {{ delivery.completedAt | date:'dd.MM.yyyy HH:mm' }}.</p>
        <p>{{ delivery.marked }} merket som sendt · {{ delivery.alreadySent }} allerede merket · {{ delivery.skipped }} hoppet over.</p>
        <p *ngIf="delivery.skipped" class="muted">Sjekklister som mangler, ikke er signert, eller har utelatte PDF-er eller PDF-er utenfor utvalget, merkes ikke som sendt.</p>
      </div>
      <p class="muted retention">Tilgjengelig til {{ job.expiresAt | date:'dd.MM.yyyy HH:mm' }}.</p>
    </mat-card>

    <mat-card *ngIf="report?.failed" class="failures-card">
      <h2>Filer som trenger oppfølging ({{ report.failed }})</h2>
      <p *ngIf="canRecover">Du kan generere PDF-ene på nytt eller fortsette uten dem. Nye PDF-er erstatter de lagrede eksportene med dagens sjekklisteinnhold og prosjektets bildekvalitet.</p>
      <div class="actions" *ngIf="report.status === 'AWAITING_DECISION'">
        <button mat-raised-button color="primary" (click)="regenerate()" [disabled]="!canRecover">Generer alle på nytt</button>
        <button mat-stroked-button (click)="retry()" [disabled]="!canRecover">Kontroller filene på nytt</button>
        <button mat-button (click)="skipFailures()" [disabled]="!canRecover">Lag ZIP uten filene som feilet</button>
      </div>
      <div class="scroll-table" tabindex="0" role="region" aria-label="Filer som ikke blir med i ZIP-filen">
        <table>
          <thead><tr><th scope="col">Fil</th><th scope="col">Trinn</th><th scope="col">Årsak</th><th scope="col" *ngIf="canRecover">Handling</th></tr></thead>
          <tbody>
            <tr *ngFor="let failure of failures">
              <td class="file-name">{{ failure.name }}</td><td>{{ failure.stage }}</td><td>{{ failure.reason }}</td>
              <td *ngIf="canRecover"><button mat-button (click)="regenerate(failure.path)" [disabled]="!canRecover"
                  [attr.aria-label]="'Generer på nytt: ' + failure.name">Generer på nytt</button></td>
            </tr>
          </tbody>
        </table>
      </div>
      <button mat-button *ngIf="nextOffset !== null" (click)="loadMoreFailures()" [disabled]="loadingFailures || requestPending">
        {{ loadingFailures ? 'Laster…' : 'Vis flere feil' }}
      </button>
    </mat-card>

    <mat-card *ngIf="report" class="objects-card">
      <h2>Objekter i PDF-utvalget ({{ objectCount }})</h2>
      <p class="muted">Objektene som PDF-ene i denne eksporten tilhører, også PDF-er som eventuelt feilet.</p>
      <mat-progress-bar *ngIf="loadingObjects" mode="indeterminate" aria-label="Laster objekter"></mat-progress-bar>
      <div *ngIf="objects.length" class="scroll-table object-table" tabindex="0" role="region" aria-label="Objekter i eksporten">
        <table>
          <thead><tr><th scope="col">Objekt</th><th scope="col">TFM / RDS</th><th scope="col">PDF-er i utvalget</th></tr></thead>
          <tbody>
            <tr *ngFor="let object of objects">
              <td><a *ngIf="!object.missing" class="object-link" [routerLink]="['/p', projectId, 'o', object.id]">{{ object.name }}</a>
                <span *ngIf="object.missing">{{ object.name }} (slettet)</span></td>
              <td>{{ object.tfmTag || object.rdsTag || '–' }}</td><td>{{ object.pdfCount }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <button mat-button *ngIf="nextObjectOffset !== null" (click)="loadObjects(true)" [disabled]="loadingObjects || requestPending">Vis flere objekter</button>
    </mat-card>
  </ng-container>
</main>
